import * as React from 'react';
import { DeviceSelector, DeviceType } from '@sevone/insight-connect';
import { RenderVariableProps } from '../../types';
import { MAX_RESOURCES_DISPLAYED } from '../utils';
import { useSingleSelection } from '../use-single-selection';
import { ConfigurationType, OptionType, ValueType } from './types';

type Props = RenderVariableProps<ConfigurationType, OptionType, ValueType>;

function Variable(props: Props) {
  const { value, options, config, onValueChange } = props;

  const getDeviceGroups = () => {
    if (config.selectAll) {
      return undefined;
    }

    const deviceGroups = [
      ...config.hierarchicalData,
      config.value
    ].find((data) => {
      return data && data.type === 'DEVICE_GROUP';
    });

    // For some reason TS needs us to check again for `type` here.
    if (!deviceGroups || deviceGroups.type !== 'DEVICE_GROUP') {
      return [];
    }

    return deviceGroups.resources;
  };

  const getOptions = () => {
    if (config.selectAll) {
      return undefined;
    }

    return options.length > 0 ? options : undefined;
  };

  const handleChange = (values: Array<DeviceType>) => {
    const nextValue = values.length ? {
      type: 'DEVICE',
      resources: values
    } : null;

    onValueChange(nextValue);
  };

  const handleFetchValueError = () => {
    onValueChange(null);
  };

  const {
    isSingleOption,
    handleOptionsChange
  } = useSingleSelection(value?.resources, handleChange, [
    options,
    config.selectAll
  ]);

  return (
    <DeviceSelector
      clearable={config.isClearable}
      disabled={isSingleOption}
      isMulti={config.isMulti && !isSingleOption}
      maxDisplayed={MAX_RESOURCES_DISPLAYED}
      datasources={config.datasources}
      value={value ? value.resources : []}
      deviceGroups={getDeviceGroups()}
      deviceOptions={getOptions()}
      onChange={handleChange}
      onOptionsChange={handleOptionsChange}
      onFetchValueError={handleFetchValueError}
    />
  );
}

export { Variable };
